import { render, staticRenderFns } from "./show.participants.page.vue?vue&type=template&id=242891ae&"
import script from "./show.participants.page.vue?vue&type=script&lang=js&"
export * from "./show.participants.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports